/**
 * GradeCell — single editable score cell in the IE/DS grades grid.
 *
 * Props:
 *   value       {string}             current input value
 *   error       {string|null}        per-cell 422 message
 *   saving      {boolean}            true while the API call is in flight
 *   cellRef     {React.Ref}          forwarded ref for focus management
 *   onChange    {(val: string)=>void}
 *   onCommit    {()=>void}           called on blur or keyboard commit
 *   onKeyDown   {(e: KeyboardEvent)=>void}
 *   'data-cell-id' {string}          for test targeting
 */

const GradeCell = ({
  value,
  error,
  saving,
  cellRef,
  onChange,
  onCommit,
  onKeyDown,
  ...rest
}) => {
  const hasError = Boolean(error);

  return (
    <div className="relative flex flex-col gap-0.5">
      <input
        ref={cellRef}
        type="number"
        min="0"
        max="20"
        step="0.5"
        value={value}
        disabled={saving}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onCommit}
        onKeyDown={onKeyDown}
        className={[
          'w-16 text-center rounded-lg border py-1.5 px-2 font-montserrat text-sm',
          'bg-[#F5F5F5] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#EAF4FB] transition-all',
          hasError
            ? 'border-red-500 focus:border-red-500'
            : 'border-transparent focus:border-[#17386E]',
          saving ? 'opacity-50 cursor-wait' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      />
      {hasError && (
        <p className="absolute top-full left-0 mt-0.5 text-xs text-red-600 whitespace-nowrap z-10 bg-white shadow rounded px-1 py-0.5">
          {error}
        </p>
      )}
    </div>
  );
};

export default GradeCell;
